// extracted by mini-css-extract-plugin
module.exports = {"header-image":"_Layout_header-image_3E9Mt","terms":"_Layout_terms_3aRMf","logo":"_Layout_logo_3GFlp"};